var subpage = {
    ajaxbleItem: 'is-ajaxable',
    init: function() {
        var self = this;

        self.selectSiteLinks();
        self.initAjaxable();

		if( jQuery( '.curtain' ).hasClass( 'animate-items' ) ) {
			self.unanimatePage( 800 );
		}
    },
	
    selectSiteLinks: function() {
        var self = this;

        var host = jQuery( 'body' ).attr( 'host' );

		var not_a = `.${self.ajaxbleItem}`;
		var not_f = '[data-fancybox]';
		var not_p = '[href$=".pdf"]';
		var not_h = '[href^="#"]';

        jQuery( `#site a:not(${not_a}):not(${not_h}):not(${not_f}):not(${not_p})[href^="${host}"]` ).each(function(){
            if( ! jQuery( this ).attr( 'data-fancybox' ) ) {
                jQuery( this ).addClass( 'is-ajaxable' );
            }
        });
    },

    initAjaxable: function() {
        var self = this;

        // set title
        jQuery( '.content--active' ).attr( 'title', document.title );

        jQuery( document).on( 'click', `.${self.ajaxbleItem}`, function( event ) {
            if( ! jQuery( this ).hasClass( self.ajaxbleItem ) ) {
                return false;
            }

            event.preventDefault();

            var clickedItem = jQuery( this );
            
            var link = clickedItem.attr( 'href' );
            var host = jQuery( 'body' ).attr( 'host' );
            var uri = link.replace( host, '' );

            self.animatePage( uri, link );
        });
    },

    animatePage: function( uri, link ) {
        var self = this;
            
        jQuery( '.curtain' ).addClass( 'animate-items' );
		setTimeout(() => {
			window.location.href = link;
		}, 800 );
	},

	unanimatePage: function( timer ) {
		var self = this;

        setTimeout( function() {
            jQuery( '.curtain' ).addClass( 'hide-items' );
        }, 0 );
        
        setTimeout( function() {
            jQuery( '.curtain' ).removeClass( 'animate-items' );
            jQuery( '.curtain' ).removeClass( 'hide-items' );
        }, timer + 350 );

	},
}

export {
    subpage
};	